import classNames from 'classnames';
import React, { forwardRef } from 'react';

const Arrow = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  ({ className = '', ...props }, ref) => (
    <svg
      viewBox="0 0 24 24"
      className={classNames(className)}
      ref={ref}
      {...props}
    >
      <path
        d="M11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289L19.7071 11.2929C20.0976 11.6834 20.0976 12.3166 19.7071 12.7071L12.7071 19.7071C12.3166 20.0976 11.6834 20.0976 11.2929 19.7071C10.9024 19.3166 10.9024 18.6834 11.2929 18.2929L16.5858 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H16.5858L11.2929 5.70711C10.9024 5.31658 10.9024 4.68342 11.2929 4.29289Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
      />
    </svg>
  )
);

export default Arrow;
